import { Component, Input } from "@angular/core";
import { BmAnalyticsCard } from "../../pojo/bm-analytics-classes";


@Component({
  selector: 'app-bm-analytics-card',
  templateUrl: './bm-analytics-card.component.html',
  styleUrls: ['./bm-analytics-card.component.scss', '../main/bm-analytics.component.scss'],
  standalone: true,
  imports: []
})
export class BmAnalyticsCardComponent {
  @Input() data: BmAnalyticsCard;
}
